import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-not-found',
  imports: [TranslateModule],
  styles: [
    `
      .not-found-container {
        margin-top: 5rem;
      }
    `
  ],
  template: `
    <div class="not-found-container flex flex-col items-center  bg-gray-50">
      <p class="text-4xl text-gray-600 mb-3 font-bold">
        404
      </p>
      <img src="assets/images/empty-bot.png" class="w-[15em]" />
    </div>
  `,
})
export class NotFound {}
